import React from 'react';

import { getCSSVariable } from '@opendoor/bricks-next';
import { navTransactionIcon } from 'components/account/navTransactionIcon';
import { isDashboardSlug } from 'components/landing-pages-v2/utils/slug';
import { useObservability } from 'helpers/observability';
import { navTransactionLabel, useNavTransactions } from 'helpers/useNavTransactions';

import { MenuLinkItem } from '../components/MenuLinkItem';

interface MobileMenuAccountItemsProps {
  slug: string;
}

const ICON_SIZE = 20;
const ICON_STROKE = 1.5;

/**
 * Mobile account items: Dashboard, active transactions, and Account settings.
 * Rendered inside the account section of {@link MobileMenuList}.
 */
export const MobileMenuAccountItemsV2: React.FC<MobileMenuAccountItemsProps> = ({ slug }) => {
  const { trackEvent } = useObservability();
  const transactions = useNavTransactions();
  const iconColor = getCSSVariable('$contentPrimary', 'color');

  return (
    <>
      <MenuLinkItem
        key="dashboard"
        href="/dashboard"
        name="Dashboard"
        analyticsName="cosmos-mobile-nav-dashboard"
        isActive={isDashboardSlug(slug)}
        onPress={() =>
          trackEvent('cta-click', 'dashboard-link', undefined, {
            categoryOverride: 'homepage',
          })
        }
      />
      {transactions.map((transaction) => {
        const Icon = navTransactionIcon(transaction.type);
        return (
          <MenuLinkItem
            key={transaction.id}
            href={transaction.href}
            name={navTransactionLabel(transaction)}
            analyticsName={`cosmos-mobile-nav-${transaction.type}`}
            isActive={false}
            icon={<Icon size={ICON_SIZE} stroke={ICON_STROKE} color={iconColor} />}
          />
        );
      })}
      <MenuLinkItem
        key="account"
        href="/account"
        name="Account settings"
        analyticsName=""
        isActive={slug === '/account'}
        isLast
        onPress={() =>
          trackEvent('cta-click', 'account-link', undefined, { categoryOverride: 'homepage' })
        }
      />
    </>
  );
};
